import router from './router'
import store from './store'
import { Toast } from 'vant'
import { getWeixInfo } from '@/utils/auth'
import { GetUrlParame } from '@/utils/fun'
import {setWeixInfo} from "./utils/auth";
import {setCookie} from "@/utils/cookie";
const whiteList = ['/bindingLogin', '/login', '/autoLogin'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  Toast.clear() // 切换页面时立马关闭提示
  if (to.path === '/autoLogin') {
    next()
    return false
  }

  if(window.location.href.indexOf('/#/rent?QRCode')>-1) {
    setCookie('formName', 'transfer')
  }

  if(process.env.NODE_ENV === 'production') {
    if(getWeixInfo()) {
      if(to.path === '/Login') {
        next('/')
      } else {
        next()
      }
    } else {
      if(whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        if (GetUrlParame('code')) {
          const params = {
            Code: GetUrlParame('code'),
          }
          store.dispatch('GetWeixInfo', params).then(res => {
            if(res.Status !== 1) {
              next()
            } else {
              const dataStr = JSON.stringify(res.Data)
              try {
                JSON.parse(dataStr)
                next()
              }catch (e) {
                next('/bindingLogin')
              }
              // store.dispatch('GetInfo', res.Data.OpenId).then(ress => {
              //   if(ress.Status !== 1) {
              //     Toast.fail(ress.Message)
              //   } else {
              //     next()
              //   }
              // })
            }
          })
        } else {
          next('/bindingLogin')
        }
      }
    }
  } else {
    const data = {
      Balance:400,
      City: null,
      Code: "000000005597",
      Country: null,
      CreateTime: "2020-11-24T14:32:20.7143726",
      CreateTimeStr: "2020-11-24",
      DormitoryId: "de2a63bb-2249-4e49-b9c3-3325be0f358e",
      Education: "大专|三年级",
      Enable: true,
      FullAddress: "国际交流学院教学楼-11号楼-11100",
      Headimgurl: null,
      IDCard: "暂无",
      Id: "A642E01C-D02B-43C5-BFCD-D60AE030BA14",
      IsLeader: false,
      IsLeaderStr: "否",
      IsRegister: true,
      IsRegisterStr: "是",
      Key: "83a5fd9f-9c23-4136-9c4d-76b09e8db353",
      Major: "1",
      Mobile: "15706888986",
      Name: "林lj",
      Nickname: null,
      OpenId: null,
      Province: null,
      RegionExtendName: "宁波大学校区",
      RegionId: "9584f824-3b3c-45cb-bd44-89764c479ca0",
      RegionName: "宁波大学",
      Sex: 1,
      SexStr: "男",
      StudentID: "322",
      Type: null,
      Unionid: null,
      UpdateTime: "2021-03-02T10:01:37.3641033",
      UpdateTimeStr: "2021-03-02"
    }
    if (!getWeixInfo()) {
      setWeixInfo(data)
    }
    next()
  }
})
